import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/list',
      method: 'get',
      params: params
    })
  },
  allList: function (params) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/allList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmusersetmealposition/cecUnmUserSetMealPosition/import',
      method: 'post',
      data: data
    })
  }
}
